export enum PropertyDtoPlan {
  Basic = 'Basic',
  Pro = 'Pro',
}
